import { FilterOutlined } from "@ant-design/icons";
import { ComponentProps } from "@declarations/props";
export const FilterButton: ComponentProps<{
  limit: string;
  text: string;
  onFilterClick?: () => void;
}> = ({ limit, text, onFilterClick }) => {
  return (
    <>
      <div className="tw-pt-0 tw-text-primary">
        <div className="tw-flex tw-justify-between tw-items-center">
          <div className="tw-w-1/2 pocket-highlight">
            <div className="tw-text-base tw-text-primary">
              Data yang ditampilkan{" "}
              <span className="tw-font-bold">
                {limit} {text}
              </span>
            </div>
          </div>
          <div
            className="tw-w-max-1/2 tw-flex tw-justify-between tw-items-center tw-p-2 pocket-filter card-body"
            onClick={() => onFilterClick?.()}
          >
            <FilterOutlined className="tw-me-1.5 tw-text-xl tw-text-primary" />
            <div className="tw-text-sm tw-font-light tw-text-primary">
              <span className="tw-font-bold">Filter</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
